// extracted by mini-css-extract-plugin
export default {"td":"InputTableText_td__6eSeY","text":"InputTableText_text__2edmW"};